const facebookBtns = document?.querySelectorAll('.facebook-btn');
const twitterBtns = document?.querySelectorAll('.twitter-btn');
const linkedinBtns = document?.querySelectorAll('.linkedin-btn');
const pinterestBtns = document?.querySelectorAll('.pinterest-btn');
const printerBtns = document?.querySelectorAll('.printer-btn');
const chatBtns = document?.querySelectorAll('.chat-btn');

const openShareWindow = (shareUrl) => {
  const y = window.top.outerHeight / 2 + window.top.screenY - 400 / 2;
  const x = window.top.outerWidth / 2 + window.top.screenX - 600 / 2;

  window.open(
    shareUrl,
    'targetWindow',
    `toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=400,top=${y}, left=${x}`,
  );
};

facebookBtns?.forEach((item) => {
  item?.addEventListener('click', function () {
    const url = window?.location?.href;
    openShareWindow(`https://www.facebook.com/sharer/sharer.php?u=${url}`);
  });
});

twitterBtns?.forEach((item) => {
  item?.addEventListener('click', function () {
    const url = window?.location?.href;
    openShareWindow(`http://twitter.com/share?url=${url}`);
  });
});
linkedinBtns?.forEach((item) => {
  item?.addEventListener('click', function () {
    const url = window?.location?.href;
    openShareWindow(
      `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    );
  });
});
pinterestBtns?.forEach((item) => {
  item?.addEventListener('click', function () {
    const url = window?.location?.href;
    openShareWindow(`http://pinterest.com/pin/create/button/?url=${url}`);
  });
});
printerBtns?.forEach((item) => {
  item?.addEventListener('click', function () {
    window?.print();
  });
});
chatBtns?.forEach((item) => {
  item?.addEventListener('click', function () {
    zE('messenger', 'open');
  });
});
